import styled from 'styled-components';

export default styled.div`
  && {
    background-color: rgba(193, 225, 141, 1);
    padding: 0 40px 25px 40px;
    .detail {
      background-color: white;
      height: 100%;
      width: 100%;
      border-radius: 10px;
      padding: 18px 25px 0 25px;
      .input-search {
        height: 40px;
        width: 192px;
      }
      .input-search-stk {
        height: 40px;
        width: 228px;
      }
      .ant-col-offset-2 {
        padding-top: 35px;
      }
      .search {
        display: flex;
        align-items: center;
        .icon1 {
          margin-bottom: 20px;
          margin-right: 8px;
        }
        p {
          margin-bottom: 20px;
          margin-right: 10px;
        }
        .ant-form-item {
          width: 70%;
        }
      }
      .btnSearch {
        float: right;
        height: 40px;
        width: 173px;
      }
      .backSetup {
        left: 30px;
        margin-right: 10px;
        width: 80px;
        height: 40px;
        background-color: #c4c4c4;
        color: white;
        border-radius: 5px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
        :hover {
          border: 1px solid #c4c4c4;
        }
      }
    }
  }
`;
